import { render, staticRenderFns } from "./YoukeQuntiHuaxiangXingweiJiexi.vue?vue&type=template&id=19050ad8&scoped=true&"
import script from "./YoukeQuntiHuaxiangXingweiJiexi.vue?vue&type=script&lang=js&"
export * from "./YoukeQuntiHuaxiangXingweiJiexi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19050ad8",
  null
  
)

export default component.exports